import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { DefaultChart, SimpleChart } from './Components/Charts';
import { ChartContainer } from './styles';
import { useSmartChartTicks } from '../../utilities/hooks/useSmartChartTicks';
export var ExpectedPerformanceChart = function (props) {
  var chartLineForContribution = props.chartLineForContribution,
    chartLineForProjection = props.chartLineForProjection,
    variant = props.variant;
  var chartContainerRef = useRef(null);
  var _a = useSmartChartTicks(chartContainerRef),
    xTickValues = _a[0],
    setTicksCapValue = _a[1];
  var projectionData = chartLineForProjection.data.slice(-1)[0];
  useEffect(function () {
    var contributionData = chartLineForContribution.data;
    var projectionData = chartLineForProjection.data;
    var contributionYears = new Date(contributionData[contributionData.length - 1].x).getFullYear() - new Date(contributionData[0].x).getFullYear() + 1;
    var projectionYears = new Date(projectionData[projectionData.length - 1].x).getFullYear() - new Date(projectionData[0].x).getFullYear() + 1;
    setTicksCapValue(Math.min(projectionYears, contributionYears));
  }, [chartLineForContribution, chartLineForProjection]);
  if (variant === 'simple') {
    var xAxisFormatter_1 = props.xAxisFormatter,
      yAxisFormatter_1 = props.yAxisFormatter,
      xFormat_1 = props.xFormat,
      yFormat_1 = props.yFormat;
    return _jsx(ChartContainer, {
      ref: chartContainerRef,
      children: _jsx(SimpleChart, {
        chartLineForContribution: chartLineForContribution,
        chartLineForProjection: chartLineForProjection,
        xAxisFormatter: xAxisFormatter_1,
        xFormat: xFormat_1,
        yAxisFormatter: yAxisFormatter_1,
        yFormat: yFormat_1
      })
    });
  }
  var chartAreasLegendText = props.chartAreasLegendText,
    chartAreasLegend = props.chartAreasLegend,
    chartTooltipText = props.chartTooltipText,
    chartLinesLegend = props.chartLinesLegend,
    xAxisFormatter = props.xAxisFormatter,
    yAxisFormatter = props.yAxisFormatter,
    xFormat = props.xFormat,
    yFormat = props.yFormat;
  return _jsx(ChartContainer, {
    ref: chartContainerRef,
    children: _jsx(DefaultChart, {
      areasLegendText: chartAreasLegendText,
      areasLegendType: chartAreasLegend,
      chartLineForContribution: chartLineForContribution,
      chartLineForProjection: chartLineForProjection,
      chartTooltipText: chartTooltipText,
      linesLegendType: chartLinesLegend,
      projectionData: projectionData,
      xAxisFormatter: xAxisFormatter,
      xFormat: xFormat,
      xTickValues: xTickValues,
      yAxisFormatter: yAxisFormatter,
      yFormat: yFormat
    })
  });
};